const isServer = typeof window === 'undefined';
export const CUSTOM_BASE_URL = process.env.NEXT_PUBLIC_SITE_URL ?? (!isServer && window.location.origin);
export const FULL_URL = !isServer ? window.location.href : '';
export const CLIENT_BASE_URL = !isServer ? window.location.origin : '';
export const BASE_URL =
  process.env.NEXT_PUBLIC_APP_ENV === 'production'
    ? 'https://www.restworld.it'
    : process.env.NEXT_PUBLIC_APP_ENV === 'development'
    ? 'http://localhost:4200'
    : 'https://dev.worker.restworld.it';

// www and never the bare apex: https://restworld.it answers 301 to www, and the WhatsApp client
// builds no link preview behind that redirect (verified 14/10/2026). These URLs get shared.
export const CUSTOM_EMPLOYER_BASE_URL =
  process.env.NEXT_PUBLIC_APP_ENV === 'production'
    ? 'https://www.restworld.it'
    : process.env.NEXT_PUBLIC_APP_ENV === 'development'
    ? 'http://localhost:4200'
    : 'https://dev.employer.restworld.it';
